<template>

  <tr v-if="!isCertFile(file.usr_file_type)">
    <td  class="center-header">
      <div class="checkbox-holder checkbox-holder-transferedfile" v-if="isAdmin">
        <input 
          type="checkbox" 
          :id="'checkbox-' + file.file_id"
          :checked="isSelected" 
          @change="selectFile(file, helico)"
        >
        <label 
          :for="'checkbox-' + file.file_id"
        ></label>
      </div>
    </td>
    <td class="truncate"  :title="formatDateAndTime(file.upload_date, true)">{{ formatDateAndTime(file.upload_date, false) }}</td>
    <td class="truncate"  :title="file.initial_file_name">{{ truncateText(file.initial_file_name ? file.initial_file_name : 'n/a', maxUserFileName) }}</td>
    <td class="truncate"  :title="file.file_name">{{ formatFileName(file.file_name) }}</td>
    <td>{{ file.usr_file_type ? file.usr_file_type : 'n/a'}} </td>
    <td>{{ file.target }}</td>
    <td class="status"  :class="{'failed' : file.transfer_status === 'failed'}">{{ $t('transfer.' + file.transfer_status) }}</td>
    <td class="truncate" :title="formatDateAndTime(file.last_updated, true)">{{ formatDateAndTime(file.last_updated, false) }}</td>
    <td>{{ file.rejected ? file.rejected + '/3' : '0/3' }}</td>
  </tr>

  <tr v-else-if="isCertFile(file.usr_file_type)">
    <td class="truncate"  :title="formatDateAndTime(file.upload_date, true)">{{ formatDateAndTime(file.upload_date, false) }}</td>
    <td>{{ file.usr_file_type ? file.usr_file_type : 'n/a'}} </td>
    <td>{{ file.target }}</td>
    <td class="status"  :class="{'failed' : file.transfer_status === 'failed'}">{{ $t('transfer.' + file.transfer_status) }}</td>
    <td class="truncate" :title="formatDateAndTime(file.last_updated, true)">{{ formatDateAndTime(file.last_updated, false) }}</td>
    <td class="truncate" :title="formatDateAndTime(file.cert_expiration, true)" >{{ formatDateAndTime(file.cert_expiration, false) }}</td>
  </tr>
  
  </template>
  
  
  
  <script>
  import { mapActions, mapGetters } from 'vuex';
  import { DateService } from '../utils/dateService'

  export default {
    props: {
      file: {
        type: Object,
        required: true
      },
      helico: {
        type: Object,
        required: true
      },
      selectedFiles: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        maxUserFileName: 20,
        maxFileName: 18
      }
    },
    computed: {
      ...mapGetters('userStore', ['isAdmin', 'isAHAdmin']),

      isSelected() {
        return this.selectedFiles.some(f => f.the_file.file_id === this.file.file_id);
      }
    },
    methods: {
      selectFile(file, helico) {
        this.$emit('file-selected', file, helico);
      },
      truncateText(text, maxLength) {
        if (text && text.length > maxLength) {
          return text.substring(0, maxLength) + '...'; // Truncate text
        }
        return text;
      },
      formatDateAndTime (time, showall) {
        if (showall) {
          return DateService.formatDateAndTime(this.$moment, time);
        } else {
          return DateService.formatDateOnly(this.$moment, time);
        }
      },
      extractFileName(filename) {
        let split = filename.split(".zip_");
        if (split.length === 2) {
            return split[0] + ".zip";
        }
        else {
            return filename;
        }
      },
      formatFileName(filename) {
        return this.truncateText(this.extractFileName(filename), this.maxFileName);
      },
      isCertFile(filename) {
      return filename === 'CERTIF' || filename === 'PRIVATE_KEY';
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  tr {
    width: 100%;
    th,
    td {

      min-width: 130px;
      padding: 12px 15px;
      font-size: 14px;
      border: none;
    }
    td.center-header {
      min-width: 39px;
      vertical-align: middle;
    }
    th {
      color: #8e9ba4;
    }
    td {
      color: #00205b;
      font-weight: 400;
      &.status {
        font-weight: 600;
        &.failed {
          color: #e3002b;
        }
      }
      .truncate {
        max-width: 100px; /* Adjust as needed */
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span.abort {
        background-color: #e3002b;
        border: none;
        border-radius: 290486px;
        cursor: pointer;
        pointer-events: auto;
        display: inline-block;
        flex-grow: 0;
        flex-shrink: 0;
        font-size: 0;
        height: 20px;
        max-height: 20px;
        max-width: 20px;
        min-height: 20px;
        min-width: 20px;
        outline: none;
        position: relative;
        vertical-align: top;
        width: 20px;
        &:before,
        &:after {
          background-color: white;
          content: "";
          display: block;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translateX(-50%) translateY(-50%) rotate(45deg);
          transform-origin: center center;
        }
        &:before {
          height: 2px;
          width: 50%;
        }
        &:after {
          height: 50%;
          width: 2px;
        }
      }
      span.trash {
        position: relative;
        cursor: pointer;
      }
      .trash-holder {
        display: flex;
        justify-content: center;
        align-self: center;
        img {
          height: 20px;
        }
      }
    }
  }

.checkbox-holder-transferedfile label::after {
  line-height: 0px;
}

// added because there was alignment issues with the original checkbox-holder
.checkbox-holder-transferedfile {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0;
  
  input[type="checkbox"],
  label {
    margin: 0;
    margin-top: -2px; // might need to tweak this
  }
}

</style>
